'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InstagramIcon = function (_React$Component) {
    _inherits(InstagramIcon, _React$Component);

    function InstagramIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, InstagramIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InstagramIcon.__proto__ || Object.getPrototypeOf(InstagramIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height, primary) {
            return _react2.default.createElement(
                'svg',
                { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 43.258 43.258' },
                _react2.default.createElement(
                    'g',
                    { id: 'instagram_pink', 'data-name': 'instagram pink', transform: 'translate(-197.178 -629.388)', fill: 'transparent' },
                    _react2.default.createElement(
                        'g',
                        { id: 'Group_2644', 'data-name': 'Group 2644', transform: 'translate(197.178 629.388)', fill: 'transparent' },
                        _react2.default.createElement('path', { id: 'Path_3626', 'data-name': 'Path 3626', d: 'M223.579,656.543a4.32,4.32,0,1,0-4.33-4.33,4.335,4.335,0,0,0,4.33,4.33Zm0,0', transform: 'translate(-201.953 -630.586)', fill: primary }),
                        _react2.default.createElement('path', { id: 'Path_3627', 'data-name': 'Path 3627', d: 'M233.7,646.561v-4.168h-.544l-3.629.013.017,4.168Zm0,0', transform: 'translate(-202.616 -630.231)', fill: primary }),
                        _react2.default.createElement('path', { id: 'Path_3628', 'data-name': 'Path 3628', d: 'M222.385,629.392a21.629,21.629,0,1,0,21.632,21.627,21.653,21.653,0,0,0-21.632-21.627Zm12.3,19.1v10.074a4.758,4.758,0,0,1-4.756,4.752H214.84a4.757,4.757,0,0,1-4.753-4.752V643.477a4.758,4.758,0,0,1,4.753-4.756h15.092a4.759,4.759,0,0,1,4.756,4.756Zm0,0', transform: 'translate(-200.759 -629.392)', fill: primary }),
                        _react2.default.createElement('path', { id: 'Path_3629', 'data-name': 'Path 3629', d: 'M229.925,652.338a6.728,6.728,0,1,1-12.961-2.524h-3.672v10.074a2.353,2.353,0,0,0,2.357,2.354h15.092a2.354,2.354,0,0,0,2.356-2.354V649.814h-3.671a6.75,6.75,0,0,1,.5,2.524Zm0,0', transform: 'translate(-201.568 -630.711)', fill: primary })
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(InstagramIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || 48;
            return _react2.default.createElement(
                _layout2.default,
                { size: size },
                this.getIcon(size, size, this.props.color)
            );
        }
    }]);

    return InstagramIcon;
}(_react2.default.Component);

exports.default = InstagramIcon;